import shortid from "shortid"

export default {
    "sandbox": {
        "slug": "sandbox",
        "units": [
            {"family": "bulbasaur", "level": 1, "affiliation": "bad", "maxhealth": 4, "moverange": 0, "skills": ["strike"], "position": {"x": 1, "y": 2, "z": 1}, "health": 2},
            // {"family": "bulbasaur", "level": 1, "affiliation": "bad", "maxhealth": 4, "skills": ["strike mid-range"], "position": {"x": 3, "y": 5, "z": 1}},
            // {"family": "bulbasaur", "level": 1, "affiliation": "bad", "maxhealth": 4, "skills": ["strike mid-range"], "position": {"x": 0, "y": 4, "z": 1}},
            // {"family": "charmander", "level": 1, "affiliation": "bad", "skills": ["strike mid-range"], "moverange": 2, "position": {"x": 1, "y": 3, "z": 1}, "health": 2},
            {"family": "squirtle", "level": 1, "affiliation": "good", "maxhealth": 7, "skills": ["readytrap"], "position": {"x": 2, "y": 2, "z": 1}},
            // {"family": "charmander", "level": 1, "affiliation": "good", "skills": ["leap", "counterattack"], "position": {"x": 2, "y": 4, "z": 1}},
        ],
        "world": {
            "reference": "C",
        }
    },
    "flat": {
        "slug": "flat",
        "units": [
            {"reference": "name:vileplume", "position": {"x": 3, "y": 4, "z": 1}, "affiliation": "good", "skills": ["strike"]},
            {"reference": "name:charizard", "position": {"x": 0, "y": 0, "z": 1}, "affiliation": "bad", "skills": ["strike"]},
            // {"reference": "name:charizard", "position": {"x": 3, "y": 4, "z": 1}, "affiliation": "good"},
            // {"reference": "name:charizard", "position": {"x": 1, "y": 5, "z": 1}, "affiliation": "good"},
        ],
        "world": {"reference": "flat"}
    },
    "hilly": {
        "slug": "hilly",
        "units": [
            {"reference": "name:charizard", "position": {"x": 0, "y": 0, "z": 2}, "affiliation": "good"},
            {"reference": "name:charizard", "position": {"x": 2, "y": 2, "z": 2}, "affiliation": "good"},
            {"reference": "name:charizard", "position": {"x": 4, "y": 5, "z": 1}, "affiliation": "good"},
            {"reference": "name:charizard", "position": {"x": 4, "y": 0, "z": 1}, "affiliation": "good"},
        ],
        "world": {"reference": "A"}
    },
    "boxed-in": {
        "slug": "boxed-in",
        "units": [
            {"reference": "name:ranger", "position": {"x": 3, "y": 2, "z": 1}, "affiliation": "good", "maxhealth": 5, "skills": ["heal"]},
            {"family": "squirtle", "level": 2, "position": {"x": 2, "y": 1, "z": 1}, "affiliation": "good", "maxhealth": 5, "skills": ["charge", "counterattack"]},
            {"family": "oddish", "level": 1, "position": {"x": 3, "y": 1, "z": 1}, "affiliation": "good", "maxhealth": 3, "skills": ["longrange-strike"]},
            {"family": "ponyta", "level": 1, "position": {"x": 2, "y": 3, "z": 1}, "affiliation": "good", "maxhealth": 4, "skills": ["strike", "readytrap"]},

            {"family": "magmar", "level": 1, "position": {"x": 0, "y": 0, "z": 1}, "maxhealth": 2, "affiliation": "bad", "skills": ["midrange"]},
            // {"family": "poliwag", "level": 1, "position": {"x": 5, "y": 4, "z": 1}, "maxhealth": 3, "affiliation": "bad", "skills": ["strike"]},
            // {"family": "poliwag", "level": 1, "position": {"x": 0, "y": 3, "z": 1}, "maxhealth": 3, "affiliation": "bad", "skills": ["strike"]},
        ],
        "world": {"reference": "E"},
        "events": {
            "1:end": [
                {"type": "spawn", "unit": {"family": "poliwag", "level": 1, "position": {"x": 0, "y": 0, "z": 1}, "maxhealth": 3, "affiliation": "bad", "skills": ["strike"]}},
                {"type": "spawn", "unit": {"family": "poliwag", "level": 1, "position": {"x": 5, "y": 4, "z": 1}, "maxhealth": 3, "affiliation": "bad", "skills": ["strike"]}},
                {"type": "spawn", "unit": {"family": "magmar", "level": 1, "position": {"x": 5, "y": 5, "z": 1}, "maxhealth": 2, "affiliation": "bad", "skills": ["midrange"]}},
            ],
            "3:end": [
                {"type": "spawn", "unit": {"family": "oddish", "level": 2, "position": {"x": 5, "y": 4, "z": 1}, "affiliation": "bad", "skills": ["midrange"], "maxhealth": 3}},
                {"type": "spawn", "unit": {"family": "magmar", "level": 1, "position": {"x": 0, "y": 3, "z": 1}, "maxhealth": 2, "affiliation": "bad", "skills": ["midrange"]}},
            ],
            "5:end": [
                {"type": "spawn", "unit": {"family": "magmar", "level": 1, "position": {"x": 5, "y": 3, "z": 1}, "maxhealth": 2, "affiliation": "bad", "skills": ["midrange"]}},
                {"type": "spawn", "unit": {"family": "magmar", "level": 1, "position": {"x": 0, "y": 3, "z": 1}, "maxhealth": 2, "affiliation": "bad", "skills": ["midrange"]}},
                {"type": "spawn", "unit": {"family": "poliwag", "level": 1, "position": {"x": 0, "y": 5, "z": 1}, "maxhealth": 3, "affiliation": "bad", "skills": ["strike"]}},
            ],
            "7:end": [
                {"type": "spawn", "unit": {"family": "charmander", "level": 3, "position": {"x": 0, "y": 5, "z": 1}, "affiliation": "bad", "maxhealth": 5, "skills": ["leap", "counterattack"]}},
            ],
        }
    },
    "around": {
        "slug": "around",
        "units": [
            {"reference": "name:venusaur", "position": {"x": 1, "y": 0, "z": 1}, "affiliation": "good", "skills": ["longrange-strike"]},
            {"reference": "name:blastoise", "position": {"x": 0, "y": 0, "z": 1}, "affiliation": "good", "skills": ["readytrap"]},
            {"reference": "name:magmar", "position": {"x": 0, "y": 1, "z": 1}, "affiliation": "good", "skills": ["midrange-strike"]},
            {"reference": "name:charizard", "position": {"x": 2, "y": 4, "z": 1}, "affiliation": "bad", "skills": ["strike"], "health": 3, "maxhealth": 3},
            {"reference": "name:magmar", "position": {"x": 4, "y": 2, "z": 1}, "affiliation": "bad", "skills": ["midrange-strike"], "health": 3, "maxhealth": 3},
        ],
        "world": {
            "reference": "center",
        }
    },
    "august-26-2020": {
        "slug": "august-26-2020",
        "world": {"reference": "august-26-2020"},
        "units": [
            // {"reference": "name:ranger", "position": {"x": 3, "y": 2, "z": 1}, "affiliation": "good", "maxhealth": 5, "skills": ["heal"]},
            {"family": "squirtle", "level": 2, "position": {"x": 2, "y": 1, "z": 1}, "affiliation": "good", "maxhealth": 5, "skills": ["strike 2-power", "counterattack"]},
            {"family": "oddish", "level": 2, "position": {"x": 3, "y": 1, "z": 1}, "affiliation": "good", "maxhealth": 3, "skills": ["strike mid-range", "counterattack mid-range"]},
            // {"family": "ponyta", "level": 1, "position": {"x": 2, "y": 3, "z": 1}, "affiliation": "good", "maxhealth": 4, "skills": ["strike", "counterattack"]},

            {"family": "magmar", "level": 1, "position": {"x": 0, "y": 0, "z": 1}, "maxhealth": 2, "affiliation": "bad", "skills": ["strike", "counterattack mid-range"]},
            {"family": "poliwag", "level": 1, "position": {"x": 5, "y": 4, "z": 1}, "maxhealth": 3, "affiliation": "bad", "skills": ["strike", "counterattack"]},
            {"family": "poliwag", "level": 1, "position": {"x": 0, "y": 3, "z": 1}, "maxhealth": 3, "affiliation": "bad", "skills": ["strike", "counterattack"]},
        ],
        "events": {
            "1:end": [
                {"type": "spawn", "unit": {"family": "poliwag", "level": 1, "position": {"x": 0, "y": 0, "z": 1}, "maxhealth": 3, "affiliation": "bad", "skills": ["strike", "counterattack"]}},
                {"type": "spawn", "unit": {"family": "poliwag", "level": 1, "position": {"x": 5, "y": 4, "z": 1}, "maxhealth": 3, "affiliation": "bad", "skills": ["strike", "counterattack"]}},
                {"type": "spawn", "unit": {"family": "magmar", "level": 1, "position": {"x": 5, "y": 5, "z": 1}, "maxhealth": 2, "affiliation": "bad", "skills": ["strike mid-range", "counterattack mid-range"]}},
            ],
            "3:end": [
                {"type": "spawn", "unit": {"family": "oddish", "level": 2, "position": {"x": 5, "y": 4, "z": 1}, "affiliation": "bad", "skills": ["midrange"], "maxhealth": 3}},
                {"type": "spawn", "unit": {"family": "magmar", "level": 1, "position": {"x": 0, "y": 3, "z": 1}, "maxhealth": 2, "affiliation": "bad", "skills": ["strike mid-range", "counterattack mid-range"]}},
            ],
            "5:end": [
                {"type": "spawn", "unit": {"family": "magmar", "level": 1, "position": {"x": 5, "y": 3, "z": 1}, "maxhealth": 2, "affiliation": "bad", "skills": ["strike mid-range", "counterattack mid-range"]}},
                {"type": "spawn", "unit": {"family": "magmar", "level": 1, "position": {"x": 0, "y": 3, "z": 1}, "maxhealth": 2, "affiliation": "bad", "skills": ["strike mid-range", "counterattack mid-range"]}},
                {"type": "spawn", "unit": {"family": "poliwag", "level": 1, "position": {"x": 0, "y": 5, "z": 1}, "maxhealth": 3, "affiliation": "bad", "skills": ["strike", "counterattack"]}},
            ],
            "7:end": [
                {"type": "spawn", "unit": {"family": "charmander", "level": 3, "position": {"x": 0, "y": 5, "z": 1}, "affiliation": "bad", "maxhealth": 5, "skills": ["leap", "counterattack"]}},
            ],
        }
    },
}
